import type { CustomLoginFormMessages } from "./CustomLoginForm";
import { DEFAULT_PASSWORD_REQUIREMENT_LABELS } from "./PasswordRequirements";

export const DEFAULT_CUSTOM_LOGIN_FORM_MESSAGES = {
  accessibility: {
    assetWatchLogoAriaLabel: "AssetWatch",
    hidePassword: "Hide password",
    showPassword: "Show password",
  },
  headings: {
    signInTitle: "Sign In",
    signInDescription: "Authenticate with your AssetWatch account.",
    updatePasswordTitle: "Let's update your password",
    updatePasswordDescription:
      "Create a strong password to secure your account",
    accountCreatedTitle: "Account created successfully.",
    accountCreatedDescription:
      "Your account is ready - start monitoring assets and preventing downtime.",
    twoFactorTitle: "Two-factor authentication",
    twoFactorDescription: "Enter the code from your authenticator app.",
  },
  labels: {
    email: "Email",
    password: "Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    verificationCode: "Verification Code",
  },
  placeholders: {
    email: "Email",
  },
  actions: {
    rememberMe: "Remember me",
    continue: "Continue",
    forgotPassword: "Forgot password?",
    reachOutToSupport: "support@assetwatch.com",
    login: "Login",
    loginWithSso: "Login with SSO",
    retry: "Retry",
    saveChanges: "Save changes",
    startMonitoring: "Start monitoring",
    setNewPassword: "Set New Password",
    changeEmail: "Change Email",
    submit: "Submit",
  },
  loading: {
    checking: "Checking",
    updatingPassword: "Updating password",
    loggingIn: "Logging in",
    verifying: "Verifying",
    redirecting: "Redirecting",
    ssoRedirecting: "Signing in with SSO...",
  },
  copy: {
    newPasswordPrompt:
      "Please enter a new password to replace the temporary one. Your new password must:",
    passwordRequirementsHeading: "Your password must include",
    temporaryPasswordPrompt: "Please enter the temporary password we sent to:",
    temporaryPasswordHelp: "Need a new temporary password? Contact your CSM.",
    confirmPasswordMismatch: "Passwords do not match.",
    supportQuestion: "Questions?",
  },
  status: {
    passwordUpdatedSuccess:
      "Password updated successfully. Please log in with your new password.",
    temporaryPasswordUpdatedSuccess:
      "Temporary password updated successfully. Please log in with your new password.",
  },
  errors: {
    invalidEmail: "Please enter a valid email.",
    incorrectEmailOrPassword: "Incorrect email or password.",
    accountNotConfirmed:
      "Your account isn't confirmed. Please check your email for a verification code.",
    passwordResetRequired:
      "You must reset your password before signing in. Please use 'Forgot password?' to reset.",
    tooManyAttempts: "Too many attempts. Please wait and try again later.",
    network: "Network error. Please check your connection and try again.",
    generic: "Something went wrong. Please try again.",
    passwordHistoryViolation:
      "This password was used previously. Please choose a new password that you haven't used in your last 12 passwords.",
    invalidPasswordPolicy: "Password does not meet the policy requirements.",
    updatePasswordGeneric: "Error updating password. Please try again.",
    invalidMfaCode: "Invalid MFA code entered. Please try again.",
    identityProviderUndefined: "Identity provider is not defined.",
    unsupportedSignInStep: "Unsupported sign-in step.",
  },
  passwordRequirements: DEFAULT_PASSWORD_REQUIREMENT_LABELS,
} satisfies CustomLoginFormMessages;
